<section
  class="carousel"
  [ngClass]="{
    'filters-container': habilitarcheck,
    'filters-container-nopading': !habilitarcheck
  }"
>
  <ng-container *ngFor="let filterItem of chipList">
    <div
      [ngClass]="{
        'chip-filter':
          !(selectedFilter === filterItem.state && filter) && habilitarcheck,
        'chip-filter-selected': selectedFilter === filterItem.state && filter,
        'chip-filter-bordered': !habilitarcheck
      }"
      (click)="applyFilter(filterItem)"
    >
      <div
        [ngClass]="{
          'chip-content': filterItem.iconName,
          'chip-content-not-icon': !filterItem.iconName
        }"
        class="chip-content-layout"
      >
        <mat-icon class="chip-filter-icon" *ngIf="filterItem.iconName">{{
          filterItem.iconName
        }}</mat-icon>
        <div class="fs-14">
          {{ filterItem.text | titlecase }} {{ filterItem.value }}
        </div>
      </div>
    </div>
  </ng-container>

  <div
    [matMenuTriggerFor]="menu"
    class="chip-filter"
    *ngIf="menuList.length > 0"
  >
    <div class="separatorchip">|</div>
    <div class="chip-content chip-content-layout">
      <mat-icon class="chip-filter-icon">more_vert</mat-icon>
      <div class="fs-14">More</div>
    </div>
  </div>

  <mat-menu #menu="matMenu" style="padding-bottom: 0">
    <ng-container *ngFor="let filterItem of menuList">
      <button mat-menu-item (click)="applyFilter(filterItem)">
        <mat-icon class="chip-filter-icon">{{ filterItem.iconName }}</mat-icon>
        <span class="fs-14"
          >{{ filterItem.text | titlecase }} {{ filterItem.value }}</span
        >
      </button>
    </ng-container>
  </mat-menu>
</section>
